import { PERMISSION } from '@/constants/permission.constant';

const sellerTypeList = () => import('@/views/configuration/seller-types/List.vue');
const sellerTypeAdd = () => import('@/views/configuration/seller-types/Add.vue');
const sellerTypeEdit = () => import('@/views/configuration/seller-types/Edit.vue');

export const sellerTypeRoute = [
  {
    path: '/configuration/seller-types',
    name: 'seller-type',
    component: sellerTypeList,
    meta: { requiresAuth: false, permissions: [PERMISSION.SELLER_TYPE_READ] },
  },

  {
    path: '/configuration/seller-types/create',
    name: 'seller-type-create',
    component: sellerTypeAdd,
    meta: { requiresAuth: false, permissions: [PERMISSION.SELLER_TYPE_CREATE] },
  },
  {
    path: '/configuration/seller-types/:id/edit',
    name: 'seller-type-edit',
    component: sellerTypeEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.SELLER_TYPE_UPDATE] },
  },
];
